export default __webpack_public_path__ + "images/RAU-Logo-2x_94b1a438c07761980526db6de55fecae.jpg";